module.exports = __webpack_public_path__ + "static/media/default-affiliate-logo.e360e4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/default-affiliate-logo.png
// module id = 389
// module chunks = 0